
<div
  class="Paragraphe"
  :class="jel_getClassObject(content)"
  v-html="jel_replaceTokens(content.richText)"
></div>
